<template>
  <div>
    <section class="hero">
      <div class="hero-head">
        <div class="logo-container">
          <figure class="image is-square">
            <img src="@/assets/SteadBytes.svg" alt>
          </figure>
        </div>
      </div>
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1 is-size-2-mobile has-text-primary">
            <typer
              @typing-complete="showSubtitle = true"
              :typeCharDelay="titleTypeDelay"
              :remainIdle="false"
              :text="'Ben_Steadman'"
            ></typer>
          </h1>
          <h2 class="subtitle is-3 is-size-4-mobile has-text-link">
            <br v-if="!showSubtitle">
            <typer
              v-if="showSubtitle"
              @typing-complete="startTerminal"
              :typeCharDelay="titleTypeDelay"
              :text="'Software_Engineer'"
              :remainIdle="true"
            ></typer>
          </h2>
          <div class="hero-description is-size-4">
            <p>
              Striving for efficient, effective and easy to use systems that
              achieve complex goals. I build software that meets real needs; solving problems and helping others.

              <br>
              <br>

              My current focus is engineering robust data-intensive systems; providing a platform to empower other teams across the business.
              I also have a keen interest in lower level systems software (especially with Rust) and functional programming.
            </p>
            <br>
            <p>
              Take a look at my <a href="/blog">blog</a> for articles on software engineering, programming, education and other tangential topics.
              My public and Open Source work is available on my <a href="https://github.com/SteadBytes">GitHub</a> account.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-terminal">
      <div class="container">
        <index-terminal ref="terminal" :username="terminalUsername"></index-terminal>
      </div>
    </section>
  </div>
</template>

<script>
import Typer from "./typer/Typer";
import IndexTerminal from "./IndexTerminal";

export default {
  components: { IndexTerminal, Typer },
  data() {
    return {
      showSubtitle: false,
      titleTypeDelay: 100,
      terminalUsername: "ben@steadbytes",
    };
  },
  methods: {
    startTerminal() {
      this.$refs.terminal.start();
    }
  }
};
</script>

<style lang="scss">
section.section.section-terminal {
  padding-top: 0;
}

.logo-container {
  margin: 0 auto 4rem;
  max-width: 128px;
}

.title {
  &.section-title {
    &::after {
      content: " ";
      border: 4px solid #278ecc;
      display: block;
      margin: 0 auto;
      margin-top: 30px;
      width: 50px;
    }
  }
  &.is-1 {
    font-size: 4rem;
  }
}
.subtitle {
  &.is-3 {
    font-size: 2.5rem;
  }
}
</style>
